module.exports = __webpack_public_path__ + "img/produktbroschuren_it.a9bd68e3.png";